import React from 'react';

type PageTitleProps = {
  children: React.ReactNode;
};

const PageTitle: React.FC<PageTitleProps> = ({ children }) => (
  <h1 className="w-full mt-8 mb-0 text-center">{children}</h1>
);

export default PageTitle;
